import { useNavigate, useLocation, useOutletContext, useParams } from 'react-router-dom';

export const withRouting = Component => props => (
  <Component navigate={useNavigate()} location={useLocation()} params={useParams()} {...props} />
)

export const withOutletProps = Component => props => (
  <Component {...props} {...useOutletContext()} />
)
